import { useCallback, useEffect, useState } from "react"

import { useLazyGetInstallationDevicesTrendQuery } from "store/api/widgetsApi"

import { DEFAULT_PERIOD, TrendCard } from "./TrendCard"
import { computeTrend } from "./useTrendData"

export const InstallationDevicesCard = () => {
  const [period, setPeriod] = useState(DEFAULT_PERIOD)
  const [trigger, { data }] = useLazyGetInstallationDevicesTrendQuery()

  useEffect(() => {
    trigger({ period })
  }, [period, trigger])

  const installed = computeTrend(data?.data?.instaled_devices, period)
  const ordered = computeTrend(data?.data?.ordered_devices, period)

  const handlePeriodChange = useCallback((newPeriod: number) => {
    setPeriod(newPeriod)
  }, [])

  return (
    <TrendCard
      title="Installation & Thermostats"
      onPeriodChange={handlePeriodChange}
      columns={[
        {
          label: "Installed thermostats",
          value: installed.value,
          tooltip: "Total installed thermostats",
          tooltipPeriod: {
            period,
            lastPeriodCount: installed.lastPeriodCount,
            prevPeriodCount: installed.prevPeriodCount,
            unit: "thermostats",
          },
          trend: installed.trend,
          chart: installed.chart,
        },
        {
          label: "Ordered thermostats",
          value: ordered.value,
          tooltip: "Number of ordered thermostats",
          tooltipPeriod: {
            period,
            lastPeriodCount: ordered.lastPeriodCount,
            prevPeriodCount: ordered.prevPeriodCount,
            unit: "thermostats",
          },
          trend: ordered.trend,
          chart: ordered.chart,
        },
      ]}
    />
  )
}
